export default [
  {
    path: '',
    name: 'refund_applications',
    component: () => import('./List.vue'),
  },
  {
    path: ':id',
    name: 'refund_application',
    component: () => import('./Detail.vue'),
    props: true,
  },
]
